import { n as noop } from './noop-BzN7sYrl.js';
import { createContext, useContext } from 'react';

const defaultValues = {
    isInLayoutProvider: false,
    hasInLayoutActions: false,
    setHasInLayoutActions: noop,
};
const DataListLayoutContext = createContext(defaultValues);
function useDataListLayoutContext() {
    return useContext(DataListLayoutContext);
}

export { DataListLayoutContext as D, defaultValues as d, useDataListLayoutContext as u };
